<template>
  <div class="processPage">
    <ul class="ulBox clearFloat">
      <li class="blockLi">
        <div class="right">
          <el-table
            :data="itemList" stripe border style="width: 100%" size="mini">
            <el-table-column type="index" align="center"/>
            <el-table-column label="组件行号" width="80px" prop="posnr" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.posnr ? scope.row.posnr : '-'}}
                  
                </span>
              </template>
            </el-table-column>
            <el-table-column label="行项目类" width="80px" prop="postp" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.postp}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="组件编码" width="150px" prop="matnr" align="center">
              <template slot-scope="scope">
                <span :class="{disabled_line: scope.row.xloek}">{{scope.row.matnr ? scope.row.matnr : '-'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="组件描述" show-overflow-tooltip width="150px" prop="matnr" align="center">
              <template slot-scope="scope">
                <span :class="{disabled_line: scope.row.xloek}">{{scope.row.maktx ? scope.row.maktx : '-'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="需求数量" width="80px" prop="bdmng" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.bdmng}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="承诺数量" width="80px" prop="vmeng" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.vmeng}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="已领数量" width="80px" prop="enmng" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.enmng}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="计量单位" width="80px" prop="meins" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.meins}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="发料工厂" width="80px" prop="werks" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.werks}}
                </span>
              </template>
            </el-table-column>            
            <el-table-column label="发料仓位" width="80px" prop="lgort" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.lgort ? scope.row.lgort : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="替代标识" width="80px" prop="alpgr" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.alpgr ? scope.row.alpgr : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="替代比" width="80px" prop="ewahr" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.ewahr}}%
                </span>
              </template>
            </el-table-column>
            <el-table-column label="替代优先级" width="100px" prop="alprf" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.alprf}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="交货已完成" width="100px" prop="kzear" align="center">
              <template slot-scope="scope">                
                <span :class="{disabled_line: scope.row.xloek}">
                  {{scope.row.kzear ? scope.row.kzear : '-'}}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
    </ul>
  
  </div>
</template>
<script>
import {apiSapItemsSearch,apiSapOrderItemExport} from "@/api/SapOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  computed: {
   
  },
  components: {
  },
  data() {
    return {
      itemList:[],
      numPages:0,
      src: '',
    };
  },
  methods: {
    async onSearch(callback) {
      const res = await apiSapItemsSearch({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.itemList = res.data;
        if (callback) callback();
      }
    },
    
    onPrintItem() {
      this.$confirm(`确定打印套料单吗？`, "打印套料单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiSapOrderItemExport({
          id: this.tabPaneValue,
        });
        //打印
        const blob = new Blob([res], { type: 'application/pdf;charset=utf-8' });
        var date = (new Date()).getTime()
        var ifr = document.createElement('iframe')
        ifr.style.frameborder = 'no'
        ifr.style.display = 'none'
        ifr.style.pageBreakBefore = 'always'
        ifr.setAttribute('id', 'printPdf' + date)
        ifr.setAttribute('name', 'printPdf' + date)
        ifr.src = window.URL.createObjectURL(blob)
        document.body.appendChild(ifr)
        this.doPrint('printPdf' + date)
        window.URL.revokeObjectURL(ifr.src)

      })
    },
    doPrint(val) {
      var ordonnance = document.getElementById(val).contentWindow
      setTimeout(() => {
        ordonnance.print()
      }, 100)
}
    
  }

};
</script>
<style lang="less" scoped>
.disabled_line {
  text-decoration: line-through;
}
</style>
